import { render } from "./AnimatedGradient.vue?vue&type=template&id=06b66a8b&scoped=true"
import script from "./AnimatedGradient.vue?vue&type=script&lang=js"
export * from "./AnimatedGradient.vue?vue&type=script&lang=js"

import "./AnimatedGradient.vue?vue&type=style&index=0&id=06b66a8b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06b66a8b"]])

export default __exports__